export function getStatusVariant(
  value: string | number
): "default" | "secondary" | "destructive" | "outline" | "success" | "warning" | "info" {
  if (typeof value === "number") {
    if (value >= 200 && value < 300) return "success";
    if (value >= 400 && value < 500) return "warning";
    if (value >= 500 || value === 0) return "destructive";
    return "info";
  }

  const status = value.toLowerCase();

  if (status === "active") {
    return "success";
  }

  if (status === "success") {
    return "success";
  }

  if (status === "warning") {
    return "warning";
  }

  if (status === "suspended") {
    return "warning";
  }

  if (["approved", "completed", "funded", "preapproved"].includes(status)) {
    return "success";
  }

  if (status === "kba") {
    return "info";
  }

  if (["pending", "created", "signed", "processing"].includes(status)) {
    return "warning";
  }

  if (
    ["declined", "failed", "error", "fraud", "cancelled", "voided", "declined_by_bank"].includes(
      status
    )
  ) {
    return "destructive";
  }

  if (["expired", "closed", "credit_freeze"].includes(status)) {
    return "secondary";
  }

  return "info";
}
